import React from "react"

import {
  DetailCompare,
  DetailSearch,
} from "components/organisms/panel/detailSearch"
import { DetailSearchProps } from "components/pages/main/tool"
import { MainContainer } from "components/molecules/utils/mainContainer"
import { DataDescription } from "../../organisms/panel/dataDescription"
import { SymbolSearchDisclaimerText } from "config/disclaimerText"
import { checkIsSp } from "../../../utils/util"

export const SearchTemplate: React.FC<DetailSearchProps> = props => {
  const isSP = checkIsSp()
  return (
    <MainContainer>
      <div>
        {props.searchState.isComparePage ? (
          <DetailCompare {...props} />
        ) : (
          <DetailSearch {...props} />
        )}
      </div>
      {!isSP && (
        <DataDescription
          className="panel-data-description"
          children={SymbolSearchDisclaimerText}
        />
      )}
    </MainContainer>
  )
}
